module.exports = __webpack_public_path__ + "img/world-of-tanks.1df7fb5d.png";